import React from 'react';
import styled from 'styled-components';

import { Button, Input, theme } from 'components';
import TemplateDropdown, {
  TemplateDropdownType,
} from '@app/template/TemplateDropdown';

interface TemplateHeaderProps {
  templates: TemplateDropdownType;
  selectedTemplate: string;
  dropdownDisabled?: boolean;
  previewing: boolean;
  subject?: string;
  limitWidth?: boolean;
  disableSubject?: boolean;
  onPreview: (preview: boolean) => void;
  onDropdownChange: (id: string) => void;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  dataCy?: string;
}

const TemplateHeader: React.FC<TemplateHeaderProps> = ({
  templates,
  selectedTemplate,
  dropdownDisabled,
  previewing,
  subject,
  limitWidth,
  disableSubject,
  onPreview,
  onDropdownChange,
  onInputChange,
  dataCy,
}) => (
    <MessageOptionsContainer data-cy={dataCy}>
      <InputGroup stretch>
        <label data-cy="use-template-label">Use Template</label>
        <DropdownContainer
          limitWidth={limitWidth}
          data-cy={'use-template-dropdown'}
        >
          <TemplateDropdown
            templates={templates}
            value={selectedTemplate}
            onChange={onDropdownChange}
            disabled={dropdownDisabled}
          />
        </DropdownContainer>
      </InputGroup>
      <InputGroup stretch>
        <label htmlFor="subject" data-cy="subject-label">
          Subject
        </label>
        <Input
          value={subject}
          onChange={onInputChange}
          id="subject"
          disabled={disableSubject}
          data-cy="subject-input"
        />
      </InputGroup>
      <StyledButton
        onClick={() => onPreview(!previewing)}
        strong
        data-cy="preview-button"
      >
        {previewing ? 'Exit Preview' : 'Preview'}
      </StyledButton>
      <a href="/#/template/manage">
        <StyledButton
          type="default"
          strong
          data-cy="manage-templates-button"
          style={{ marginLeft: '5px' }}
        >
          Manage Templates
        </StyledButton>
      </a>
    </MessageOptionsContainer>
  );

export default TemplateHeader;

const MessageOptionsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  row-gap: 10px;
  margin-bottom: 16px;
`;

const InputGroup = styled.div<{ stretch?: boolean }>`
  &:not(:last-child) {
    margin-right: 16px;
  }
  ${({ stretch }) => (stretch ? 'flex: 1;' : '')}
`;

const DropdownContainer = styled.div<{ limitWidth?: boolean }>`
  max-width: ${({ limitWidth }) => (limitWidth ? '25vw' : 'auto')};
`;

const StyledButton = styled(Button)`
  && {
    color: ${theme.gray8};
  }
`;
